import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const RedBull = ({featuredProjectsList}) => {
  const project = getProject('red-bull');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <VimeoVideo
          className="g-row"
          component={{
            posterVideo: '215749457'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            Red Bull Music Academy Radio had been broadcasting online for more
            than 10 years. Facing a crowded market dominated by streaming
            giants, the beverage brand needed stronger positioning for its Radio
            platform to appeal to a broader audience.
          </p>
        </AnimateIn>

        <Image
          className="g-row"
          component={{
            image:
              '//images.yourmajesty.co/20170503201021/rbmaradio_case_ooh_lawall2.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="moving-forward-side-by-side">Moving forward, side-by-side</h2>
          <p>
            Your Majesty’s collaborative discovery process, an immersive
            workshop with Red Bull’s senior management and additional in-depth
            research, lead to a clear definition of the brand positioning moving
            forward.
          </p>
        </AnimateIn>

        <Image
          className="g-row component--no-margin"
          component={{
            image:
              '//images.yourmajesty.co/20170503201034/rbmaradio_case_ooh_window-ny.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image:
              '//images.yourmajesty.co/20170503201002/rbmaradio_case_mag2.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            The new vision was approached through solving these four main
            objectives:
          </p>
          <ol>
            <li>Drive awareness and traffic to RBMA.</li>
            <li>
              Be flexible enough to promote shows with vastly different
              audiences.
            </li>
            <li>
              Creating cohesive out of home, print, digital, social, retail,
              packaging and PR messaging.{' '}
            </li>
            <li>
              Communicate the brand’s strong musical perspective with a sense of
              urgency.
            </li>
          </ol>
        </AnimateIn>

        <Image
          className="g-row component--no-margin"
          component={{
            image:
              '//images.yourmajesty.co/20170503201043/rbmaradio_case_show_la1.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image:
              '//images.yourmajesty.co/20170503201041/rbmaradio_case_popup_detroit.jpg',
            caption:
              'Influencer/partnership support timed with Red-Bull sponsored festivals. © Philip Cosores and Jeremy Deputat / Red Bull'
          }}
        />

        <Image
          className="g-row component--no-margin"
          component={{
            image:
              '//images.yourmajesty.co/20170503201015/rbmaradio_case_ooh_busshelter.jpg'
          }}
        />

        <Image
          className="g-row component--no-margin"
          component={{
            image:
              '//images.yourmajesty.co/20170503201010/rbmaradio_case_ooh_bus.jpg'
          }}
        />

        <Image
          className="g-row component--no-margin"
          component={{
            image:
              '//images.yourmajesty.co/20170503201155/rbmaradio_case_4pack.jpg'
          }}
        />

        <Image
          className="g-row component--no-margin"
          component={{
            image:
              '//images.yourmajesty.co/20170503201027/rbmaradio_case_ooh_wildposting_la.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image:
              '//images.yourmajesty.co/20170503201023/rbmaradio_case_ooh_subway.jpg',
            caption:
              'Offline and at the local level, traditional guerrilla (takeover) advertising, PR, market-specific content.'
          }}
        />

        <Image
          className="g-row component--no-margin"
          component={{
            image:
              '//images.yourmajesty.co/20170503201055/rbmaradio_case_social.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image:
              '//images.yourmajesty.co/20170503200956/rbmaradio_case_banners.jpg',
            caption:
              'On the web, rich media banners pulled real-time, on-air show information to drive immediacy and click through.'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="outcomes">Outcomes</h2>
          <p>
            RBMA Radio’s traffic increased astoundingly, enabling it to solidify
            contracts with more high-profile hosts and artists.
          </p>
          <p>
            Success in the U.S caught the attention of many new fans and RMBA
            Radio is currently rolling out in the U.K, with additional markets
            planned.
          </p>
        </AnimateIn>

        <AnimateIn className="text g-row">
          <h2 id="partners">Partners</h2>
          <p>motive</p>
        </AnimateIn>

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: [
                  'Collaborative Working Sessions',
                  'Communications Strategy',
                  'Creative Strategy',
                  'Research',
                  'Roadmapping',
                  'Workshop & Facilitation'
                ]
              },

              {
                title: 'Design',
                items: [
                  'Art Direction',
                  'Brand Design',
                  'Creative Direction',
                  'Visual Design'
                ]
              },

              {
                title: 'Content',
                items: ['Copywriting']
              }
            ]
          }}
        />

        <LinkButton
          className="g-row"
          component={{
            url: 'https://redbullradio.com/',
            title: 'Visit website'
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default RedBull;
